import { render, staticRenderFns } from "./nuevoDatoFiscalModal.vue?vue&type=template&id=6d6d1e88&"
import script from "./nuevoDatoFiscalModal.vue?vue&type=script&lang=js&"
export * from "./nuevoDatoFiscalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm,QSelect,QInput,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QSelect,QInput,QBtn})
